<!-- 由 suu 创建于 2021-10-08 星期五 -->
<template>
  <div class="newoutline">
    <van-empty description="暂无训练大纲" v-if="$route.query.uid == 'null'" />
    <template v-else>
      <!-- 头部 -->
      <div class="header" v-if="user.truename">
        <div class="h-top">
          <span class="t-name">{{ user.truename }}的体测数据</span>
          <span class="t-btn" @click="onTest">全部数据</span>
        </div>
        <div class="message" v-if="user.truename">
          <div class="item">
            <div class="title">会籍在线</div>
            <div class="number">
              {{ user.online_days || '-' }}
              <span>天</span>
            </div>
          </div>
          <div class="item">
            <div class="title">体重</div>
            <div class="number">
              {{ user.weight }}
              <span>kg</span>
            </div>
          </div>
          <div class="item">
            <div class="title">体脂</div>
            <div class="number">
              {{ user.fat }}
              <span>%</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容列表 -->
      <section v-if="user.truename || user.shopname">
        <div
          class="panel outline"
          :class="{ 'outline-2': item.is_use == 3 }"
          v-for="(item, index) in user.outline"
          v-if="user.outline.length > 0 && !(item.is_use == 3 && ufrom)"
          :key="index"
        >
          <div
            :class="{ 'nor-outline': true, 'ac-outline': item.openPlay }"
            @click.stop="handleOutlinePreviewJump(item.id)"
          >
            <!-- is_use 0: 执行中 1: 已执行 3: 未发布 2: 已发布未执行 -->
            <div
              class="title"
              :class="{
                'title-2': item.is_use == 1,
                'title-3': item.is_use == 2 || item.is_use == 3,
                'title-user': item.is_use == 0 && ufrom == 'vip',
                'title-yc': item.is_use != 1 && item.use_type == 6
              }"
            >
              <!-- <div
              class="title-block"
              :class="{'title-block-2': item.is_use == 1, 'title-block-3': (item.is_use == 2 || item.is_use == 3), 'title-block-user': (item.is_use == 0 && ufrom == 'vip') }"
            ></div>-->
              <div
                class="title-left-yc u-text-center"
                v-if="item.use_type == 6"
              >
                孕产<br />训练
              </div>
              <div class="title-left">
                <div class="title-div">
                  {{
                    item.name || item.s_date.split('').splice(0, 7).join('')
                  }}期训练大纲
                  <span
                    :class="{
                      't-status-user': item.is_use == 0 && ufrom == 'vip'
                    }"
                    v-if="item.is_use == 0"
                    >执行中</span
                  >
                  <span class="t-status-2" v-if="item.is_use == 2">待执行</span>
                  <span class="t-status-3" v-if="item.is_use == 1">已执行</span>
                  <span class="t-status-2" v-if="item.is_use == 3">未发布</span>
                </div>
                <div class="time">
                  {{ item.s_date.replace(/-/g, '.') }}-{{
                    item.e_date.replace(/-/g, '.').slice(-5)
                  }}
                </div>
              </div>
              <i
                v-if="!ufrom && item.is_use != 1"
                class="el-icon-edit-outline"
                @click.stop="onShowOutline(item)"
              ></i>
            </div>
            <div class="ks-desc">
              计划课时：{{ item.total_class }}
              <span></span>
              已上课：{{ item.use_num || 0 }}
              <span></span>
              编写：{{ item.c_name }}
            </div>
          </div>
          <transition-group id="tran" name="drog" tag="div">
            <div
              class="plans"
              :class="{
                'plans-over':
                  plan.status == '已执行' || plan.status == '超时执行',
                'plan-no': !plan.target
              }"
              v-if="item.openPlay"
              @click="onPlanShow(plan)"
              v-for="(plan, pIndex) in item.new_plan"
              :key="pIndex"
            >
              <span class="title-region">
                <span class="plan-left">{{ pIndex + 1 }}</span>
                <span class="plan-info">
                  <span class="plan-title">{{
                    (plan.is_test == 1 ? '体测 + ' : '') +
                    (plan.target || '未编写')
                  }}</span>
                  <span
                    class="user-day"
                    v-if="plan.edit_time && plan.edit_time != '0'"
                  >
                    {{ plan.edit_time.split(' ')[0] | filterTime }}编写
                    <template
                      v-if="
                        plan.use_day ||
                        (plan.is_current == 1 && item.is_use == 0) ||
                        plan.status == '超时执行'
                      "
                    >
                      <span class="user-line"></span>
                      <span
                        class="user-do user-do-user"
                        v-if="plan.status == '超时执行' && ufrom != 'vip'"
                      >
                        已失效
                        <i
                          class="iconfont iconzhuyishixiang"
                          @click.stop="
                            $router.push('/know-base-detail?tid=110')
                          "
                        ></i>
                      </span>
                      <span
                        class="user-do"
                        :class="{ 'user-do-user': ufrom == 'vip' }"
                        v-if="plan.use_day"
                        >{{ plan.use_day | filterTime }}<br />已执行</span
                      >
                      <span
                        class="user-do"
                        :class="{ 'user-do-user': ufrom == 'vip' }"
                        v-if="
                          plan.is_current == 1 &&
                          item.is_use == 0 &&
                          !plan.use_day
                        "
                        >本节课执行</span
                      >
                    </template>
                  </span>
                </span>
                <i
                  class="el-icon-sort"
                  v-if="
                    pIndex != 0 &&
                    (plan.status != '已执行' || plan.status != '超时执行') &&
                    !ufrom &&
                    plan.target
                  "
                  @click.stop="exchangePlan(item, pIndex, index)"
                ></i>
              </span>
              <div
                class="cwxl-reigon"
                v-if="
                  (!ufrom && plan.target) ||
                  ((plan.status != '已执行' || plan.status != '超时执行') &&
                    !ufrom)
                "
              >
                <div
                  class="cwxl-btn user-btn"
                  v-if="
                    plan.status != '已执行' &&
                    plan.status != '超时执行' &&
                    item.is_use != 1 &&
                    !ufrom
                  "
                  @click.stop="goPlan(plan, index)"
                >
                  编辑
                </div>
              </div>
            </div>
          </transition-group>
          <div class="other-more user-btn" @click="onPlanClick(index)">
            {{ item.openPlay ? '收起' : '展开' }}
            <i class="el-icon-arrow-down" v-if="!item.openPlay"></i>
            <i class="el-icon-arrow-up" v-else></i>
          </div>
        </div>
        <div class="no-list" v-if="user.outline && user.outline.length <= 0">
          训练规划师还未给该会员编写新的训练大纲、训练计划
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { Empty } from 'vant'
export default {
  name: 'newoutline',

  components: { [Empty.name]: Empty },

  props: {},

  data() {
    return {
      user: {
        id: null,
        img: 'https://cdnvue.gymcity.com.cn/uploads/pub-red-logo',
        truename: '',
        sex: '',
        age: 0,
        shopname: '',
        temp: null, // 1对1瘦身包
        temp_6: null, // 产后
        coach: '',
        e_date: '',
        is_bodyassess: 1,
        is_pq: 1,
        all_day: '-',
        use_times: '-',
        weight: '-',
        fat: '-',
        require: [],
        question: [],
        outline: []
      }
    }
  },
  filters: {
    filterTime(time) {
      if (time) {
        return time.slice(0, 16).replace(/-/g, '.')
      } else {
        return ''
      }
    }
  },
  computed: {
    ufrom() {
      // return this.$route.query.ufrom || 'vip' // app中只有会员查看 默认vip
      return 'vip' // app中只有会员查看 默认vip
    }
  },

  watch: {},

  activated() {
    //  获取训练大纲重新请求标志位（更改计划、大纲时更新大纲列表）
    let reload = this.$store.state.reOutline
    console.log('reload', reload)
    if (reload) {
      // this.user.outline = []
      this.$store.commit('setReOutline', false)
      this.getInfo()
    }
    if (
      this.user.id &&
      String(this.user.id) !== String(this.$route.query.uid)
    ) {
      this.getInfo()
    }
  },

  created() {
    this.getInfo()
    this.$http.get('member/index?a=shareLogPush', {
      from: `训练大纲-曝光-app`,
      from_id: 250326
    })
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 查看训练计划详情
    onPlanShow(p) {
      if (p.target) {
        if (String(p.id).indexOf(':') !== -1) {
          this.$router.push(
            'newplanshow?pid=' +
              p.id +
              '&uid=' +
              this.user.id +
              '&ufrom=' +
              this.ufrom
          )
        } else {
          this.$router.push(
            'training-plan-show?pid=' +
              p.id +
              '&uid=' +
              this.user.id +
              '&ufrom=' +
              this.ufrom
          )
        }
      }
    },
    // 计划列表 收起 展开
    onPlanClick(i) {
      this.user.outline[i].openPlay = !this.user.outline[i].openPlay
    },
    /**
     * 去体测数据
     */
    onTest() {
      this.$http._toVueH5Url(
        'training-pro' + location.search,
        'push',
        '身体评估'
      )
      // if (this.ufrom === 'vip') {
      //   this.$router.push(`/training-pro?uid=${this.user.id}&ufrom=vip`)
      // } else {
      //   this.$router.push(`/training-pro?uid=${this.user.id}`)
      // }
    },
    /**
     * 获取信息
     */
    getInfo() {
      this.$toast.loading('获取信息中··')
      this.$http
        .get(
          'plan/outline',
          {
            uid: this.$route.query.uid,
            a: 'getOutlineList'
            // identity_sign: 'coach'
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.user = res.data.data
            // vip端过滤AI核查中/不通过的计划
            this.filterVipAiPlans()
            if (
              this.ufrom &&
              this.user.outline &&
              this.user.outline.length > 0
            ) {
              this.user.outline[0].openPlay = true
            }
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
          setTimeout(() => {
            this.$toast.clear()
          }, 300)
        })
        .catch((err) => {
          this.$dialog.alert({ message: err.data.msg + ' 请重试' })
          this.$toast.clear()
        })
    },
    /**
     * vip端过滤：将AI核查中/不通过的计划置为空对象
     */
    filterVipAiPlans() {
      if (!this.user.outline) return
      this.user.outline.forEach((outline) => {
        if (!outline.new_plan) return
        outline.new_plan.forEach((plan, index) => {
          const isFail =
            plan.check_err_id > 0 && plan.ai_status == 'AI核查不通过'
          const isChecking =
            plan.check_err_id > 0 && plan.ai_status == 'AI核查中'
          if (isFail || isChecking) {
            outline.new_plan[index] = {}
          }
        })
      })
    },
    // 训练大纲预览页跳转
    handleOutlinePreviewJump(id) {
      if (String(id).indexOf(':') !== -1) {
        this.$router.push({
          path: '/newoutlineshow',
          query: {
            id
          }
        })
      } else {
        this.$router.push({
          path: '/outline-preview',
          query: {
            id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.newoutline {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  background-color: #f7f7f7;
  text-align: left;
  color: #000;
  font-family: PingFang-SC-Regular;
  position: relative;
  border-bottom: solid vw(50) #f4f3f3;
  box-sizing: border-box;
  z-index: 14;
  .header {
    width: 91.5vw;
    background-color: #fff;
    padding: 4.8vw 5.3vw;
    margin-top: 5.3vw;
    border-radius: 1.6vw;
    box-sizing: border-box;
    .h-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .t-name {
        font-size: 3.7vw;
        font-weight: 600;
      }
      .t-date {
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        margin-left: 3.7vw;
      }
      .t-btn {
        font-size: 3.2vw;
        flex: 1;
        text-align: right;
      }
    }
    .message {
      width: 100%;
      background-color: #fff;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      box-sizing: border-box;
      margin-top: 4.8vw;
      text-align: center;
      .item {
        width: 33.3%;
        .number {
          font-size: 4.8vw;
          font-weight: 600;
          span {
            font-family: PingFang-SC-Medium;
            font-size: 2.7vw;
            font-weight: 400;
            margin-right: vw(2);
          }
        }
        .title {
          font-size: 3.2vw;
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
  section {
    flex: 1;
    width: 100%;
    .panel {
      margin: 0 4.3vw;
      border-radius: 1.6vw;
      border: solid 0.3vw #f1f1f1;
      box-sizing: border-box;
      text-align: left;
      padding: 3.7vw 0;
      margin-top: 2.7vw;
      background-color: #fff;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
    }
    .user-panel {
      margin-right: 0;
      margin-left: 0;
      border-radius: 0;
    }
    // 待发布
    .outline-2 {
      color: #9b9b9b;
    }
    .outline {
      font-size: vw(11);
      padding-top: 0;
      .title {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 3.7vw 0;
        // justify-content: space-between;
        box-sizing: border-box;
        background-color: #4a90e2;
        padding-left: 4.3vw;
        color: #fff;
        border-top-left-radius: 1.6vw;
        border-top-right-radius: 1.6vw;
        .title-block {
          background-color: #4a90e2;
          width: 1.6vw;
          height: 10.7vw;
          margin-right: 3.5vw;
        }
        .title-block-2 {
          background-color: #cccccc;
        }
        .title-block-3,
        .title-block-user {
          background-color: #dc0050;
        }
        .title-left {
        }
        .title-left-yc {
          width: 9.6vw;
          height: 9.9vw;
          box-sizing: border-box;
          font-size: 2.7vw;
          letter-spacing: 0.3vw;
          margin-right: 2.7vw;
          border-radius: 1.6vw;
          border: solid 0.5vw #ffffff;
        }
        .title-div {
          display: flex;
          align-items: center;
          font-size: 4.3vw;
          font-weight: 600;
          span {
            background-color: #fff;
            border-radius: 0.8vw;
            font-size: 2.7vw;
            color: #4a90e2;
            padding: 0 1.6vw;
            font-weight: 450;
            margin-left: 2.4vw;
          }
          .t-status-2,
          .t-status-user {
            color: #dc0050;
          }
          .t-status-3 {
            // background-color: #cccccc;
            color: rgba(0, 0, 0, 0.5);
          }
        }
        .time {
          font-size: 3.2vw;
          // color: rgba(0, 0, 0, 0.5);
          // margin-top: 1.1vw;
        }
        .wait-span {
          border: 1px solid #9b9b9b;
          color: #9b9b9b;
        }
      }
      .title-2 {
        background-color: #cccccc;
      }
      .title-3,
      .title-user {
        background-color: #dc0050;
      }
      .title-yc {
        background-color: #f59393;
      }
      .ks-desc {
        width: 82.9vw;
        padding: 1.1vw 3.2vw;
        margin: 0 auto;
        box-sizing: border-box;
        // background-color: #f7f7f7;
        // border-radius: 1.1vw;
        // border: solid 0.3vw #f1f1f1;
        display: flex;
        align-items: center;
        font-size: 3.2vw;
        color: rgba(0, 0, 0, 0.5);
        margin-top: 1.9vw;
        flex-wrap: wrap;
        span {
          width: 0.3vw;
          height: 2.7vw;
          background-color: #e7e7e7;
          margin: 0 2.4vw;
        }
      }
      .plans {
        width: 82.7vw;
        padding: 2.9vw 3.2vw;
        background-color: #ffffff;
        border-radius: 1.6vw;
        border: solid 0.3vw #f1f1f1;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 2.7vw;
        .title-region {
          flex: 1;
          display: flex;
          align-items: center;
          text-align: left;
          .plan-left {
            font-size: 4.8vw;
            font-weight: 600;
            margin-right: 4.3vw;
          }
          .plan-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            .plan-title {
              font-size: 3.7vw;
              font-weight: 600;
            }
            .user-day {
              color: rgba(0, 0, 0, 0.5);
              font-size: 3.2vw;
              margin-top: 1.1vw;
              display: flex;
              align-items: center;
              .user-line {
                margin: 0 2vw;
                width: 0.3vw;
                height: 2.7vw;
                background-color: #e7e7e7;
              }
              .user-do {
                color: #007aff;
                font-weight: 500;
                flex: 1;
              }
              .user-do-user {
                color: #dc0050;
                // color: rgba(0, 0, 0, 0.5);
              }
              .iconzhuyishixiang {
                color: #007aff;
              }
            }
          }
          i {
            font-weight: 550;
          }
        }
        i {
          font-size: vw(18);
        }
        .cwxl-reigon {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 2.1vw;
          .cwxl-btn {
            width: 36.8vw;
            height: 8vw;
            background-color: #ffffff;
            border-radius: 1.1vw;
            border: solid 0.3vw #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 3.2vw;
          }
          .cwxl-btn + .cwxl-btn {
            margin-left: 2.7vw;
          }
        }
      }
      .plans:first-of-type {
        margin-top: 4.8vw;
      }
      .plan-no {
        color: #dc0050;
      }
      .plans-over {
        background-color: #f7f7f7;
        .plan-desc {
          color: #9b9b9b;
          font-size: vw(12);
          border: 1px solid #9b9b9b;
          padding: 0 vw(5);
          margin-bottom: vw(8);
          display: inline-block;
        }
      }
      .other-more {
        width: 26.4vw;
        height: 6.9vw;
        margin: 0 auto;
        background-color: #ffffff;
        border-radius: 3.2vw;
        border: solid 0.3vw #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 0.5);
        font-size: 3.2vw;
        margin-top: 2.2vw;
        i {
          margin-left: 2vw;
        }
      }
      .nor-outline {
      }
      .ac-outline {
      }
    }
    .no-list {
      margin: 0 vw(13);
      background-color: #fff;
      padding: vw(20);
      border-radius: vw(5);
      font-weight: 500;
      font-size: vw(14);
      text-align: center;
      margin-top: vw(20);
    }
  }
}
</style>
